module.exports = __webpack_public_path__ + "img/ok.be1abd8c.png";